import { Injectable, OnDestroy } from '@angular/core';
import { Subject } from 'rxjs';

/**
 * A service that provides an observable that emits when the component is destroyed.
 * Use with `takeUntil(this.destroy$)` to automatically unsubscribe from observables.
 *
 * Must be provided at the component level:
 * ```typescript
 * @Component({
 *   providers: [DestroyService]
 * })
 * export class MyComponent {
 *   private destroy$ = inject(DestroyService);
 *
 *   ngOnInit() {
 *     this.someService.data$
 *       .pipe(takeUntil(this.destroy$))
 *       .subscribe(data => { ... });
 *   }
 * }
 * ```
 */
@Injectable()
export class DestroyService extends Subject<void> implements OnDestroy {
  ngOnDestroy(): void {
    this.next();
    this.complete();
  }
}
